import { FC, ReactNode } from 'react';
import { Badge } from '../Badge';
import style from './index.module.css';

export const SectionTitle: FC<{ 
  badge?: string,
  append?: ReactNode,
  description?: string,
  children: ReactNode
}> = ({ badge, append, description, children }) => {
  return (
    <div className={style.sectionTitle}>
      {badge && (
        <Badge color="yellow">{badge}</Badge>
      )}
      <h2 className={style.h2}>
        <span className={style.main}>{children}</span>
        {append && (
          <div className={style.sub}>{append}</div>
        )}
      </h2>
      {description && (
        <p className={style.description}>
          {description}
        </p>
      )}
    </div>
  )
}
